import UserMessageAdd from "@/views/userMessage/UserMessageAdd";
import UserMessageList from "@/views/userMessage/UserMessageList";
import UserMessageEdit from "@/views/userMessage/UserMessageEdit";


const routes = [
  {
    path: '/UserMessage/Add',
    name: 'UserMessageAdd',
    component: UserMessageAdd,
    meta: {requiredAuth: true}
  },
  {
    path: '/UserMessage/List',
    name: 'UserMessageList',
    component: UserMessageList,
    meta: {requiredAuth: true}
  },
  {
    path: '/UserMessage/Edit/:id',
    name: 'UserMessageEdit',
    component: UserMessageEdit,
    meta: {requiredAuth: true}
  },
]

export default routes